import { useServiceContext } from "../../contexts/service";
import { TApiLab } from "../../lib/types/labs";
import { TApiTechnician } from "../../lib/types/dentalTechs";
import { useRouteNavigation } from "../../lib/common/routes";
import { evaluators, useWindowSizeMatch } from "../../lib/window-size-matcher";
import { DEVICES_SIZES_IN_PX } from "../../lib/common/constants";

type TUserInfo = TApiLab | TApiTechnician;
type TMessageUser = {
    userInfo: TUserInfo;
    className?: string;
};

export const MessageBtn = ({ userInfo, className }: TMessageUser) => {
    const {
        chats: { addUserIdToChat },
    } = useServiceContext();
    const { navigateRouteClickHandler } = useRouteNavigation();
    const { conditionFulfilled: isSmallDevice } = useWindowSizeMatch({
        condition: evaluators.lessOrEqualThan(DEVICES_SIZES_IN_PX.medium),
    });

    const openChatWindowClickHandler = (e: React.MouseEvent) => {
        addUserIdToChat({ id: userInfo.id, name: userInfo.name });
        if (isSmallDevice.fulfilled) {
            navigateRouteClickHandler("conversations", e);
        }
    };

    return (
        <button
            className={"btn " + className}
            onClick={(e) => {
                openChatWindowClickHandler(e);
            }}
        >
            <i className="fa-regular fa-message me-2"></i>
            Chat
        </button>
    );
};
